'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var index = require('../node_modules/eventemitter3/index.js');
var Event = require('./Event.js');
var Sink = require('./Sink.js');
var utils = require('./utils.js');
function getGlobalThis() {
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
}

/**
 * @returns {{ ee: EventEmitter; sink: Sink; bridge?: import("@podium/bridge").PodiumBridge }}
 */
function getGlobalObjects() {
  var objs = getGlobalThis()['@podium'];
  if (!objs) {
    objs = {};
    getGlobalThis()['@podium'] = objs;
  }
  if (!objs.ee) {
    objs.ee = new index();
  }
  if (!objs.sink) {
    objs.sink = new Sink();
  }
  return objs;
}

/**
 * @template [T=unknown]
 * @typedef {(message: Event<T>) => void} MessageHandler
 */
var _bridgeMap = /*#__PURE__*/new WeakMap();
var MessageBus = /*#__PURE__*/function () {
  function MessageBus() {
    _classCallCheck(this, MessageBus);
    /**
     * Saves a reference to the event handlers that wrap the API for @podium/bridge, so we can unsubscribe later.
     * @type {Map<MessageHandler<any>, import('@podium/bridge').EventHandler<any>>}
     */
    _classPrivateFieldInitSpec(this, _bridgeMap, new Map());
    var _getGlobalObjects = getGlobalObjects(),
      ee = _getGlobalObjects.ee,
      sink = _getGlobalObjects.sink,
      bridge = _getGlobalObjects.bridge;
    this.ee = ee;
    this.sink = sink;
    this.bridge = bridge;
  }

  /**
   * Returns an array of the 10 latest events for a channel and topic combination.
   * The array is ordered such that the the latest/newest events is at the front of the array.
   *
   * @template [T=unknown]
   * @param {string} channel
   * @param {string} topic
   * @returns {Event<T>[]}
   */
  return _createClass(MessageBus, [{
    key: "log",
    value: function log(channel, topic) {
      return this.sink.log(channel, topic);
    }

    /**
     * Get the latest event for a channel and topic.
     *
     * @template [T=unknown]
     * @param {string} channel
     * @param {string} topic
     * @returns {Event<T>}
     */
  }, {
    key: "peek",
    value: function peek(channel, topic) {
      return this.sink.peek(channel, topic);
    }

    /**
     * Publish a message for a channel and topic.
     *
     * @template [T=unknown]
     * @param {string} channel
     * @param {string} topic
     * @param {T} [payload]
     * @returns {Event<T>} Returns the {@link Event} object passed to subscribers.
     */
  }, {
    key: "publish",
    value: function publish(channel, topic, payload) {
      var event = new Event(channel, topic, payload);
      this.ee.emit(event.toKey(), event);
      this.sink.push(event);
      if (this.bridge) {
        /** @type {T | T[]} */
        var params = payload;
        if (typeof payload !== 'undefined') {
          // JSON RPC 2.0 requires that params is either an object or an array. Wrap primitives in an an array.
          var isPrimitive = typeof params === 'string' || typeof params === 'boolean' || typeof params === 'number';
          if (isPrimitive) {
            params = [payload];
          }
        }
        this.bridge.notification({
          method: "".concat(channel, "/").concat(topic),
          params: params
        });
      }
      return event;
    }
  }, {
    key: "subscribe",
    value:
    /**
     * Subscribe to messages for a channel and topic.
     *
     * @template [T=unknown]
     * @param {string} channel
     * @param {string} topic
     * @param {MessageHandler<T>} listener
     *
     * @example
     *
     * ```js
     * messageBus.subscribe('channel', 'topic', (event) => {
     *   console.log(event.payload);
     * });
     * ```
     */
    function subscribe(channel, topic, listener) {
      var _this = this;
      if (this.bridge) {
        // If there's a bridge, add a listener for the channel and topic there
        // and translate incoming messages to a @podium/browser Event for the
        // same API surface in userland.

        /** @type {import('@podium/bridge').EventHandler<T>} */
        var bridgeListener = function bridgeListener(message) {
          var request = /** @type {import("@podium/bridge").RpcRequest<T>} */
          message;
          var event = new Event(channel, topic, request.params);
          _this.sink.push(event);
          listener(event);
        };
        this.bridge.on("".concat(channel, "/").concat(topic), bridgeListener);

        // Save a reference to the bridgeListener so we can unsubscribe later.
        _classPrivateFieldGet(_bridgeMap, this).set(listener, bridgeListener);
      }
      this.ee.on(utils.toKey(channel, topic), listener);
    }

    /**
     * Remove a message listener.
     *
     * @template [T=unknown]
     * @param {string} channel
     * @param {string} topic
     * @param {MessageHandler<T>} listener
     *
     * @example
     * ```js
     * // Declare the listener so it can be passed both to `subscribe` and `unsubscribe`.
     * function listener(event) {
     *   console.log(event.payload);
     * }
     *
     * messageBus.subscribe('channel', 'topic', listener);
     *
     * messageBus.unsubscribe('channel', 'topic', listener);
     * ```
     */
  }, {
    key: "unsubscribe",
    value: function unsubscribe(channel, topic, listener) {
      this.ee.off(utils.toKey(channel, topic), listener);
      if (this.bridge) {
        var bridgeListener = _classPrivateFieldGet(_bridgeMap, this).get(listener);
        if (bridgeListener) {
          this.bridge.off("".concat(channel, "/").concat(topic), bridgeListener);
        }
      }
    }
  }]);
}();
module.exports = MessageBus;
